import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { ReplaySubject, Subscription, Observable } from 'rxjs';

export interface LanguageOption {
  description: string,
  value: string;
  webServiceLangValue?: 1 | 2;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private SUPPORTED_LANGS: LanguageOption[] = [
    {
      description: 'Italiana',
      value: 'it',
      webServiceLangValue: 1 // inusato
    },
    {
      description: 'English',
      value: 'en',
      webServiceLangValue: 2 // inusato
    }
  ];

  private activeLanguageSubject = new ReplaySubject<LanguageOption>(1);
  private _activeLanguage: LanguageOption;
  private internalSubscription: Subscription;
  private chosenLanguageKey = '__language';

  constructor(private translate: TranslateService, private storage: Storage) {
    //this.initLanguageService();
  }

  get supportedLangs(): LanguageOption[] {
    return this.SUPPORTED_LANGS;
  }

  async initLanguageService() {
    const languageToApply = await this.getDefaultLanguage();
    this.translate.setDefaultLang(languageToApply.value);
    this.activeLanguageSubject.next(languageToApply);
    this.internalSubscription = this.activeLanguageSubject.subscribe(lang => {
      this._activeLanguage = lang;
    });
  }

  /**
   * Ritorna la lingua da applicare all'applicazione usando
   * - La lingua scelta precedentemente
   * - La lingua del browser
   */
  private async getDefaultLanguage(): Promise<LanguageOption> {
    const languageDbPreference = await this.storage.get(this.chosenLanguageKey);
    if (languageDbPreference && languageDbPreference.value) {
      return JSON.parse(languageDbPreference.value);
    } else {
      // Mai settata esplicitamente
      return this.getDefaultBrowserLanguage();
    }
  }

  private getDefaultBrowserLanguage(): LanguageOption {
    switch (this.translate.getBrowserLang()) {
      case 'it':
        console.info('Lingua di default per il browser italiana');
        return this.supportedLangs[0];
      case 'en':
        console.info('Lingua di default per il browser inglese');
        return this.supportedLangs[1];
      default:
        console.warn('Lingua browser non supportata, uso inglese');
        return this.supportedLangs[1];
    }
  }

  getActiveLanguageObservable(): Observable<LanguageOption> {
    return this.activeLanguageSubject.asObservable();
  }

  /**
   * Metodo invocato nelle impostazioni per cambiare la lingua
   * applicata nell'app
   * @param newLangString sigla della lingua da applicare
   */
  async changeLanguage(newLanguage: LanguageOption): Promise<void> {
    if (newLanguage && newLanguage.value != this.activeLanguage.value) {
      console.debug(`Cambio lingua in ${newLanguage.description}`);
      this.translate.use(newLanguage.value);
      await this.storage.set(this.chosenLanguageKey,JSON.stringify(newLanguage));
      this.activeLanguageSubject.next(newLanguage);
    }
  }

  get activeLanguage(): LanguageOption {
    return this._activeLanguage;
  }

}
